import { render, staticRenderFns } from "./FoodDetail.vue?vue&type=template&id=11bf558f"
import script from "./FoodDetail.vue?vue&type=script&lang=js"
export * from "./FoodDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports